import {PUSH_VIEW, STEP_VIEW} from '../actions/viewhistory';

const MAX_ENTRIES = 50;
// Tolerance in map units (meters for EPSG:3857) below which two centers count as equal
const CENTER_TOLERANCE = 0.5;

const defaultState = {
    entries: [],
    index: -1
};

function sameView(a, b) {
    return a.zoom === b.zoom
        && Math.abs(a.center[0] - b.center[0]) < CENTER_TOLERANCE
        && Math.abs(a.center[1] - b.center[1]) < CENTER_TOLERANCE;
}

export default function viewhistory(state = defaultState, action) {
    switch (action.type) {
        case PUSH_VIEW: {
            if (state.index >= 0 && sameView(state.entries[state.index], action.view)) {
                return state;
            }
            const entries = [...state.entries.slice(0, state.index + 1), action.view].slice(-MAX_ENTRIES);
            return {entries, index: entries.length - 1};
        }
        case STEP_VIEW: {
            const index = state.index + action.delta;
            if (index < 0 || index >= state.entries.length) {
                return state;
            }
            return {...state, index};
        }
        default:
            return state;
    }
}
